import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import AvatarForm from "../forms/AvatarForm";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import useFetchBlock from "../../../../../hooks/useFetchBlock";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import {
  deleteBlock,
  resetDeletBlock,
} from "../../../../../redux/slices/block/deleteBlockSlice";
import {
  updatingAvatarCard,
  resetAvatarCard,
} from "../../../../../redux/slices/cards/cardSlice";
import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

import SpinnerGiff from "../../../../../assets/spinner.svg";

const EditAvatar = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const baseUrl = process.env.REACT_APP_API_URL;
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { themeDirection } = useSettings();
  const { setActiveMainPageNav } = useStateContext();
  const { optionId } = useParams();
  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [prevData, setPrevData] = useState(null);
  const url = baseUrl + "/api/user/getOption/" + userId + "/" + optionId;

  const { data, loading, error } = useFetchBlock(url);

  useEffect(() => {
    setPrevData({
      ...data?.data,
      coloum_value:
        data?.data?.coloum_value && JSON.parse(data?.data?.coloum_value),
    });
    if (error) {
      toast.error("Something went wrong...");
    }
  }, [data, error]);

  const [avatarLoading, setAvatarLoading] = useState(false);

  const linkId = localStorage.getItem("linkId");

  const fetchingLinksList = () => {
    // data need for fetching link list
    const usertoken = user.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    dispatch(gettingLinkList(linkListData));
  };

  const submitHandlerParent = async (data) => {
    setAvatarLoading(true);
    const formData = {};
    if (data?.picture) {
      formData.picture = data.picture;
    }
    formData.coloum_name = data?.coloum_name;
    formData.coloum_type = data?.coloum_type;
    formData.radius = data?.radius;
    formData.size = data?.size;
    formData.optionId = optionId;
    formData.linkId = linkId;
    formData.language = prevData?.language;
    await dispatch(updatingAvatarCard(formData));
    setAvatarLoading(false);
  };

  const {
    updatedavatarCard,
    avatarCardError,
    avatarCardSuccess,
    avatarLoading: avatarUpdateLoading,
    avatarCardErrorMsg,
  } = useSelector((state) => state?.cards?.avatarCard);
  useEffect(() => {
    if (updatedavatarCard?.status === "success" && avatarCardSuccess) {
      toast.success(updatedavatarCard?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (updatedavatarCard?.status === "failed" && avatarCardSuccess) {
      toast.error(updatedavatarCard?.message);
    }
    if (avatarCardError && avatarCardErrorMsg) {
      toast.error(avatarCardErrorMsg?.message);
    }
    dispatch(resetAvatarCard());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedavatarCard, avatarUpdateLoading]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const deleteHandler = async () => {
    const obj = {
      optionId: optionId,
      userId: userId,
    };
    await dispatch(deleteBlock(obj)).then(() => {});
  };

  const handleDeleteModal = () => {
    deleteHandler();
    setIsModalOpen(false);
  };

  //  delete block api response state handler
  const {
    DeleteBlock,
    isDeleteBlockError,
    isDeleteBlockSuccess,
    isDeleteBlockLoading,
    isDeleteBlockErrorMsg,
  } = useSelector((state) => state?.deleteBlock);

  useEffect(() => {
    if (DeleteBlock?.data?.status === "success" && isDeleteBlockSuccess) {
      toast.success(DeleteBlock?.data?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (DeleteBlock?.data?.status === "failed" && isDeleteBlockSuccess) {
      toast.error(DeleteBlock?.data?.message);
    }
    if (isDeleteBlockError) {
      toast.error(isDeleteBlockErrorMsg);
    }
    dispatch(resetDeletBlock());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteBlockLoading, DeleteBlock]);

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteModal}
        selectedLang={prevData?.language}
      />
      {loading && (
        <div
          style={{ zIndex: "999999" }}
          className="fixed inset-0 h-screen bg-[#ffffffa7] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      )}
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>

            <p className="dark:text-color_v1_dark"> {translate("avatar")} </p>
          </div>
        </Link>
      </div>

      <AvatarForm
        formType={"edit"}
        submitHandlerParent={submitHandlerParent}
        deleteHandlerParent={() => setIsModalOpen(true)}
        prevData={prevData}
        avatarLoading={avatarLoading}
      />
    </>
  );
};

export default EditAvatar;
